<template>
  <div id="customer">
    <!-- 合作伙伴 -->
    <div class="hzhb-box">
      <div class="container customer-container">
        <img class="img-jjfa" src="@/assets/image/hzhb.png" alt="合作伙伴">
        <!-- web -->
        <div class="swiper-container hzhb-container-box">
          <div class="swiper-wrapper">
            <div class="row justify-content-between">
              <div class="col-6 col-xs-6 col-sm-4 col-md-3 item-hzhb" v-for="(item,index) in customerList" :key="index">
                <img class="item-hzhb-img" :src="item.logo">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Customer",
  data() {
    return {
      customerList: [
        {
          logo: require("@/assets/image/zfb.png"),
        },
        {
          logo: require("@/assets/image/myl.png"),
        },
        {
          logo: require("@/assets/image/jlyq.png"),
        },
        {
          logo: require("@/assets/image/tgpt.png"),
        },
        {
          logo: require("@/assets/image/gdt.png"),
        },
        {
          logo: require("@/assets/image/cljn.png"),
        },
        {
          logo: require("@/assets/image/zglt.png"),
        },
        {
          logo: require("@/assets/image/zgyd.png"),
        },
        {
          logo: require("@/assets/image/zgdx.png"),
        },
        {
          logo: require("@/assets/image/zggd.png"),
        },
        {
          logo: require("@/assets/image/fljc.png"),
        },
        {
          logo: require("@/assets/image/mgcm.png"),
        },
        
      ],
    };
  },
  created(){
    
  },
  mounted() {
    
  }
};
</script>
<style scoped>
/* 合作伙伴 */
.hzhb-box{
  width: 100%;
  background: url("../assets/img/ppjsbg.png") 0 0 no-repeat;
  padding-top: 60px;
  padding-bottom: 60px;
  overflow: hidden;
}
.img-jjfa{
  margin: 0px auto;
}
.item-hzhb{
  margin-top:40px;
}
.item-hzhb-img{
  width:100%;
}
/* .justify-content-between{
  display:flex;
  justify-content:space-between;
} */

@media screen and (min-width: 996px){
  .customer-block {
    padding: 20px;
  }
  .hzhb-container-box{
    width:960px;
    margin-left:auto;
    margin-right:auto;
  }
  .item-hzhb{
    max-width:150px;
  }
}
@media screen and (min-width: 768px){
  .img-jjfa {
      width: 127px;
      height: 31px;
  }
}
@media screen and (max-width: 768px) {
  .customer-block{
    width: 1140px !important;
    padding:20px 0;
  }
  .img-jjfa {
    width: 127px;
    height: 31px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Customer.vue